import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { EveReportingTextWidget } from '../../text-widget/text-widget.component';




@Component({
  selector: 'text-widget-menu-settings',
  templateUrl: 'text-widget-menu-settings.component.html',
  styleUrls: ['./text-widget-menu-settings.component.css'],
  viewProviders: [
    { provide: ControlContainer, useExisting: NgForm }
  ]
})
export class TextWidgetMenuSettingsComponent implements OnInit {

  @Input()
  widget?: EveReportingTextWidget = null;

  constructor(

  ) {


  }
    ngOnInit(): void {
      if (this.widget.text == null) this.widget.text = "";
    }


}



